<app-modal-header modalTitle="Add Size Range Assignment" [showCloseBtn]="true" (closeModal)="close()" />

<div *ngIf="loading" class="h-100 w-100 flex-center-all">
    <app-loader [loadingMessage]="loadingMessage" />
</div>

<div *ngIf="!loading" class="modal-content custom-vertical-scroll" [attr.loading]="loading" [attr.size]="'medium'">
    <form [formGroup]="sraForm" (ngSubmit)="onSubmit()">
        <div class="form-fields-container">
            <div class="form-fields-container-inputs">
                <mat-form-field class="col-12">
                    <mat-label>Size Range Name</mat-label>
                    <input
                        #sizeRangeNameInput
                        matInput
                        formControlName="size_range_name"
                        placeholder="Size Range Name"
                        [matAutocomplete]="sizeRangeNameAuto"
                        (input)="filterSizeRangeNames()"
                        (focus)="filterSizeRangeNames()"
                    />
                    <mat-autocomplete #sizeRangeNameAuto="matAutocomplete" requireSelection="true">
                        <mat-option *ngFor="let option of filteredSizeRangeNames" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="sraForm.get('size_range_name').hasError('required')">
                        Size Range Name is required
                    </mat-error>
                </mat-form-field>
                <div class="form-fields-span">
                    <mat-form-field class="col-6">
                        <mat-label>Assign to Product</mat-label>
                        <mat-chip-grid #productChips formArrayName="products" required>
                            <mat-chip-row
                                *ngFor="let product of products.controls"
                                (removed)="removeProduct(product.value)"
                            >
                                {{ product.value }}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input
                            #productInput
                            matInput
                            placeholder="Assign to Product"
                            [matAutocomplete]="productIdAuto"
                            (input)="filterProducts()"
                            (focus)="filterProducts()"
                            [matChipInputFor]="productChips"
                            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                        />
                        <mat-autocomplete
                            #productIdAuto="matAutocomplete"
                            requireSelection="true"
                            (optionSelected)="productSelected($event)"
                        >
                            <mat-option *ngFor="let option of filteredProducts" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error>Product is required</mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-6">
                        <mat-label>Eligible Channel</mat-label>
                        <mat-chip-grid #channelChips formArrayName="channels" required>
                            <mat-chip-row
                                *ngFor="let channel of channels.controls"
                                (removed)="removeChannel(channel.value)"
                            >
                                {{ channel.value }}
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input
                            #channelInput
                            matInput
                            placeholder="Eligible Channel"
                            [matAutocomplete]="eligibleChannelAuto"
                            (input)="filterChannels()"
                            (focus)="filterChannels()"
                            [matChipInputFor]="channelChips"
                            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                        />
                        <mat-autocomplete
                            #eligibleChannelAuto="matAutocomplete"
                            requireSelection="true"
                            (optionSelected)="channelSelected($event)"
                        >
                            <mat-option *ngFor="let option of filteredChannels" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error>Channel is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="form-fields-span">
                    <mat-checkbox class="col-6" formControlName="is_future">Future Size Range</mat-checkbox>
                    <mat-form-field class="col-6">
                        <mat-label>Historical Size Range</mat-label>
                        <input
                            #historicalSizeRangeInput
                            matInput
                            formControlName="historical_size_range"
                            placeholder="Historical Size Range"
                            [matAutocomplete]="historicalSizeRangeAuto"
                            (input)="filterHistoricalSizeRanges()"
                            (focus)="filterHistoricalSizeRanges()"
                        />
                        <mat-autocomplete #historicalSizeRangeAuto="matAutocomplete" requireSelection="true">
                            <mat-option *ngFor="let option of filteredHistoricalSizeRanges" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="sraForm.get('historical_size_range').hasError('required')">
                            Historical Size Range is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="form-fields-container-buttons">
                <button type="submit" mat-raised-button color="accent" [disabled]="!sraForm.valid">Save</button>
                <button type="button" mat-button (click)="reset()">Reset</button>
            </div>
        </div>
    </form>
</div>

<app-modal-footer (closeModal)="close()" [closeBtnText]="'Close'" [showUpdateBtn]="false" />
